import {
  SETTINGS_USERS_LIST_ITEM,
  SETTINGS_USERS_AUTH_ITEM,
  SETTINGS_USERS_ACCESS_ITEM,
} from './settings-users-items.js'

/** @type {import('../help-index.js').HelpScreen} */
export const SETTINGS_USERS_HELP = {
  screenId: 'settings-users',
  label: 'Usuarios',
  navPath: 'Configuración → Usuarios',
  keywords: ['permisos', 'acceso', 'usuario', 'contraseña', 'autorización'].map((k) => k.toLowerCase()),
  status: 'draft',
  summary: 'Cuentas de acceso, permisos por módulo y restricción por caja, banco u otros recursos.',
  sidebarItems: [
    SETTINGS_USERS_LIST_ITEM,
    SETTINGS_USERS_AUTH_ITEM,
    SETTINGS_USERS_ACCESS_ITEM,
  ],
}
